class HttpService {

  constructor(fetchExecutor) {

    this.fetchExecutor = fetchExecutor;

  }

  get(request) {

    let fetchRequest = {
      method: 'GET',
      headers: request.headers
    };

    return this.fetchExecutor.executeFetchRequest(request.url, fetchRequest);

  }

  post(request) {

    let fetchRequest = {
      method: 'POST',
      headers: request.headers,
      body: JSON.stringify(request.body)
    };

    return this.fetchExecutor.executeFetchRequest(request.url, fetchRequest);

  }

}

export default HttpService;



// WEBPACK FOOTER //
// ./src/library/services/http/HttpService.js